import { DossierItemCategory } from 'dto/Dossier/DossierItemCategory';

export const getDossierItemCategoryLabel = (category: DossierItemCategory) => {
  switch (category) {
    case DossierItemCategory.Documents:
      return 'Dokumenty';
    case DossierItemCategory.Images:
      return 'Obrazy';
    case DossierItemCategory.Workbooks:
      return 'Arkusze kalkulacyjne';
    case DossierItemCategory.Presentations:
      return 'Prezentacje';
    case DossierItemCategory.Link:
      return 'Linki';
    case DossierItemCategory.Other:
    default:
      return 'Inne';
  }
};
